import { Badge } from '@repo/videa-components';

interface PatientConsentBlurbProps {
  blurb?: string;
}
export const PatientConsentBlurb = ({ blurb }: PatientConsentBlurbProps) => {
  return (
    <Badge
      variant="secondary"
      className="vai-px-4 vai-py-2 vai-text-sm vai-md:text-base vai-h-auto"
    >
      <span className="vai-mr-1 vai-text-muted-foreground vai-whitespace-pre-line">
        {blurb}
      </span>
    </Badge>
  );
};
